module.exports = __webpack_public_path__ + "static/media/creditcard-face.2c70e4f4.svg";